import { useState } from "react";
import SolicitarDevolucaoStep1 from "./step-1";
import SolicitarDevolucaoStep2 from "./step-2";

const PLATAFORM_LIST = [
  { plataform: "Karsten", id: 1 },
  { plataform: "Trussardi", id: 3 },
  { plataform: "Karsten Decor", id: 2 },
];

export default function NewRequestPage({ onBack }) {
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const [fieldsData, setFieldsData] = useState({
    idGrupoEconomico: null,
    idPessoa: null,
    cnpj: null,
    groupName: null,
    socialName: null,
  });
  const [plataform, setPlataform] = useState(PLATAFORM_LIST[0]);
  const [items, setItems] = useState([]);
  const [itemsWithMotivos, setItemsWithMotivos] = useState([]);
  const [solicitacao, setSolicitacao] = useState();
  const [motivoGeral, setMotivoGeral] = useState(null);
  const [defeitoGeral, setDefeitoGeral] = useState(null);

  const handleClear = () => {
    setStep(1);
    setFieldsData({
      idGrupoEconomico: null,
      idPessoa: null,
      cnpj: null,
      groupName: null,
      socialName: null,
    });
    setPlataform(PLATAFORM_LIST[0]);
    setSolicitacao(undefined);
    setItems([]);
    setItemsWithMotivos([]);
    setMotivoGeral(null);
    setDefeitoGeral(null);
  };

  const commonProps = {
    fieldsData,
    setFieldsData,
    plataform,
    setPlataform,
    setStep,
  };

  const step1Props = {
    ...commonProps,
    plataformList: PLATAFORM_LIST,
    setSolicitacao,
    isLoading,
    setIsLoading,
    item: itemsWithMotivos.length > 0 ? itemsWithMotivos : items,
    setItem: setItems,
    setItemsWithMotivos,
    onBack: onBack,
    motivoGeral,
    setMotivoGeral,
    defeitoGeral,
    setDefeitoGeral,
    solicitacao,
  };

  const step2Props = {
    ...commonProps,
    handleClear,
    solicitacao,
    setItem: setItems,
    returnToInitialPage: onBack,
    items: items,
    itemsWithMotivos,
    motivoGeral,
    defeitoGeral,
    plataform,
  };

  return (
    <>
      <div style={{ display: step === 1 ? "block" : "none" }}>
        <SolicitarDevolucaoStep1 {...step1Props} />
      </div>
      <div style={{ display: step === 2 ? "block" : "none" }}>
        <SolicitarDevolucaoStep2 {...step2Props} />
      </div>
    </>
  );
}
